import {
  Component,
  ElementRef,
  OnInit,
  ViewChild,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { InvoicesService } from '../services/invoices.service';
import { switchMap } from 'rxjs/operators';
import { EMPTY } from 'rxjs';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-invoice-preview',
  templateUrl: './invoice-preview.component.html',
  styleUrls: ['./invoice-preview.component.css'],
})
export class InvoicePreviewComponent implements OnInit {
  invoice: any;
  queryParams = {}
  @ViewChild('myIframe', { static: false }) myIframe!: ElementRef;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private invoiceService: InvoicesService,
    private sanitizer: DomSanitizer
  ) {
    // window.addEventListener('message', this.receiveMessage.bind(this), false);
  }

  ngOnInit(): void {
    const state = this.router.getCurrentNavigation()?.extras.state;
    if (state && state.invoice) {
      this.invoice = state.invoice;
    }
    this.route.queryParams.subscribe(params => {
      this.queryParams = params;
    });

    // window.addEventListener('message', this.receiveMessage.bind(this), false);

    this.route.paramMap
      .pipe(
        switchMap((params) => {
          const invoiceId = params.get('invoiceID');
          console.log('Invoice ID from path params:', invoiceId);
          if (invoiceId) {
            console.log('Fetching invoice from service');
            return this.invoiceService.getInvoice(invoiceId);
          }
          console.log('No invoice ID found, returning EMPTY');
          return EMPTY;
        })
      )
      .subscribe(
        async (response) => {
          if (response && response.data && response.data.getInvoice) {
            console.log('Invoice received:', response.data.getInvoice);
            if (!response.data.getInvoice?.nanonets){
                // if nanonets not run

              this.router.navigate(
                [
                  'invoices',
                  response.data.getInvoice.folderID,
                ],
                {
                  queryParams: this.queryParams
                }
              )
              return
            }


            const secondsFromEpochNow = Math.floor(Date.now() / 1000);
            if (
              secondsFromEpochNow > response.data.getInvoice?.nanonets?.expiresAt
            ) {
              console.log('Expored preview url');
              const res = await this.invoiceService.generatePreviewUrl(
                response.data.getInvoice.id,
                window.location.origin + '/loading'
              );
              this.invoice = res.data.generatePreviewUrl;
            } else {
              console.log(' preview url NOT expired');
              this.invoice = response.data.getInvoice;
            }
            if(!this.myIframe.nativeElement.src){
              this.myIframe.nativeElement.src = this.invoice.nanonets.previewUrl
              this.myIframe.nativeElement.width = "100%"
              this.myIframe.nativeElement.height = "100%"
            }
          } else {
            console.log('No invoice received');
          }
        },
        (error) => {
          console.error('Error fetching invoice:', error);
          // Handle error (e.g., show error message)
        }
      );
  }
  url(url: string) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url) as string;
  }
}
